import React from "react";
import { useParams } from "react-router-dom";
import ErrorScreen from "./ErrorScreen";
import NotFoundPage from "./NotFoundPage";

const MESSAGES = {
  403: "The requested resource is forbidden.",
  404: "The requested resource could not be found but may be available again in the future.",
};

const SERVER_MESSAGE =
  "An unexpected condition was encountered. Our service team has been dispatched to bring it back online.";

export default function ErrorPageRoute() {
  const { error: code } = useParams();
  const statusCode = (code || "404").slice(0, 3);
  const family = statusCode.slice(0, 2);

  let variant = "notFound";
  let message = MESSAGES[404];

  if (statusCode === "403") {
    variant = "forbidden";
    message = MESSAGES[403];
  } else if (family === "50") {
    variant = "server";
    message = SERVER_MESSAGE;
  }

  return statusCode === "404" ? (
    <NotFoundPage />
  ) : (
    <ErrorScreen variant={variant} statusCode={statusCode} message={message} />
  );
}
